<!--
=========================================================
* Vue Argon Dashboard 2 PRO - v3.0.1
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->

<template>
  <ConfirmDialog :closable="false"></ConfirmDialog>
<home>
</home>
</template>
<script>

import Home from "@/views/Home.vue";
import ConfirmDialog from "primevue/confirmdialog";
export default {
  name: "App",
  components: {
    Home,
    ConfirmDialog
  },
};
</script>
